enum ActivityLevel {
  Sedentary = "sedentary",
  SomewhatActive = "somewhatActive",
  VeryActive = "veryActive",
  HardlySitStill = "hardlySitStill",
}

const activityQuestion = {
  name: 'activity',
  title: 'How physically active are you during a typical day?',
  description: 'This gives us a picture of your daily routine when you’re not working out.',
  type: "radiogroup",
  choices: [
    {
      value: ActivityLevel.Sedentary,
      text: "<div class='icon-button'><div>🪑</div><div>I sit most of the day<br /><span class=\"small-text\">Less than 5,000 steps a day on average</span></div></div>",
    },
    {
      value: ActivityLevel.SomewhatActive,
      text: "<div class='icon-button'><div>🚶‍♂</div><div>I try to be fairly active<br /><span class=\"small-text\">5,000 - 10,000 steps a day on average</span></div></div>",
    },
    {
      value: ActivityLevel.VeryActive,
      text: "<div class='icon-button'><div>🏃‍♂</div><div>I move around a lot<br /><span class=\"small-text\">10,000 - 15,000 steps a day on average</span></div></div>",
    },
    {
      value: ActivityLevel.HardlySitStill,
      text: "<div class='icon-button'><div>🤸</div><div>I hardly ever sit still<br /><span class=\"small-text\">Over 15,000 steps a day on averge</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  ActivityLevel,
  activityQuestion,
}